module.exports = __webpack_public_path__ + "static/9f004cb1-853d-4d5c-8173-c3a5775565b5-900.977eac6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/quatrefoil-st-georges-church/9f004cb1-853d-4d5c-8173-c3a5775565b5-900.jpg
// module id = 1060
// module chunks = 168707334958949